import Map from '../EventMap'
import PhoneNumber from './PhoneNumber'
import styles from './Contact.module.scss'

export default function EventContact({
  owner,
  contact = { address: false, phone_text: false, phone: false },
  map = false,
}) {
  const { address, phone_text: phoneText, phone } = contact

  if (!address && !phone && !map) {
    return null
  }

  return (
    <section
      className={map ? styles.section : styles.sectionWithMargin}
      id="yhteystiedot"
    >
      <header>
        <h4 className={styles.title}>Yhteystiedot</h4>
      </header>

      <div className={styles.content}>
        {address && <p>{address}</p>}
        {phone && (
          <>
            {phoneText && <p className={styles.phoneText}>{phoneText}</p>}
            <PhoneNumber number={phone} owner={owner} />
          </>
        )}
      </div>

      {map && <Map map={map} title={owner} />}
    </section>
  )
}
